import type { UpdateBackOfficePayload } from "@/schema"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { updateBackOffice } from "./api"

export function useUpdateBackOffice() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateBackOfficePayload }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return updateBackOffice(context, id, payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["back-offices"] })
      queryClient.invalidateQueries({ queryKey: ["back-office"] })
    },
  })
}
